'use client';

import { CvssScoringSection } from '@terra/ui-design-system';
import { useApplicationById } from '../../../hooks/api/useApplicationById';
import { useUpdateApplicationFields } from '../../../hooks/api/useUpdateApplicationFields';

type TargetCvssPanelProps = {
  applicationId: string;
  isReadOnly?: boolean;
};

export function TargetCvssPanel({
  applicationId,
  isReadOnly,
}: TargetCvssPanelProps) {
  const { application } = useApplicationById({ id: applicationId });
  const { mutateAsync, isPending } = useUpdateApplicationFields();

  return (
    <CvssScoringSection
      settings={application}
      isPending={isPending}
      isReadOnly={isReadOnly}
      showRescoreWarning
      onSave={async (patch) => {
        await mutateAsync({ applicationId, body: patch });
      }}
    />
  );
}
